import React, { useState } from 'react';
import classNames from 'classnames';
import Input, { InputSize } from '@zvuk-b2b/react-uikit/ui/Input';
import { parseVideoPromoDuration, VIDEO_PROMO_CLOCK_PATTERN } from '../videoPromoDraft';
import type { VideoPromoFieldProps } from './types';
import { TEXTS } from './texts';
import { formatVideoPromoInput } from './utils';
import styles from './index.module.scss';

const VideoPromoField: React.FC<VideoPromoFieldProps> = ({ id, kind, value, isDisabled, onChange }) => {
  const [isTouched, setIsTouched] = useState(false);
  const isDuration = kind === 'duration';
  const isValid = isDuration ? parseVideoPromoDuration(value) !== undefined : VIDEO_PROMO_CLOCK_PATTERN.test(value);
  const isErrorVisible = isTouched && !isValid;
  const helperId = `${id}_help`;

  return (
    <div className={styles.field}>
      <Input
        elementId={id}
        label={isDuration ? TEXTS.DURATION : TEXTS.TIME}
        value={value}
        size={InputSize.SMALL}
        isDisabled={isDisabled}
        inputMode="numeric"
        autoComplete="off"
        maxLength={isDuration ? 8 : 5}
        placeholder={isDuration ? 'чч:мм:сс' : 'чч:мм'}
        labelClassName={styles.label}
        containerClassName={styles.control}
        inputClassName={classNames(styles.input, !isValid && styles.invalid, isErrorVisible && styles.errorInput)}
        forceError={isErrorVisible}
        aria-invalid={isErrorVisible}
        aria-describedby={isDuration || isErrorVisible ? helperId : undefined}
        onChange={(raw) => {
          const formatted = formatVideoPromoInput(raw, value, isDuration);
          onChange(formatted);
          return formatted;
        }}
        onBlur={() => setIsTouched(true)}
        onMouseOut={() => setIsTouched(true)}
        onEnterPressed={(event) => event.currentTarget.blur()}
      />
      {(isDuration || isErrorVisible) && (
        <div
          id={helperId}
          className={classNames(styles.helper, isErrorVisible && styles.error)}>
          {isDuration ? TEXTS.DURATION_HELP : TEXTS.TIME_HELP}
        </div>
      )}
    </div>
  );
};

export default VideoPromoField;
